import React from 'react';
import { Document, Page } from 'react-pdf';

const PDFPreview = ({isFullscreen, setPageChanged, pdfData, totalPages, setCurrentPage, currentPage}) => {

  // const previewScale = isFullscreen ? 0.53 : 0.4;
  const previewScale = isFullscreen
  ? Math.min(window.innerWidth / 1400, 0.53)
  : Math.min(window.innerWidth / 1000, 0.33);


  return (
    <Document
      file={pdfData}
      loading={<div className="d-flex align-items-center justify-content-center w-100 overflow-hidden" >
        <div className="spinner-border text-primary" role="status"></div>
      </div>}
      className="d-flex flex-column align-items-center"
    >
      {Array.from(new Array(totalPages), (_, index) => (
        <div
          key={`preview-${index + 1}`}
          className={`cursor-pointer p-2 m-1 ${
            currentPage === index + 1 ? 'pdf-bg bg-opacity-10 border rounded' : 'preview-page'
          }`}
          onClick={() => {
            setPageChanged(prev => !prev); setCurrentPage(index + 1)}}
        >
          <Page
            pageNumber={index + 1}
            scale={previewScale}
            renderTextLayer={false}
            renderAnnotationLayer={false}
            loading={<div className="d-flex align-items-center justify-content-center w-100">
              <div className="spinner-border text-primary" role="status"></div>
            </div>}
            className="shadow-sm"
          />
          <div className="small text-center mt-1 text-secondary prev-footer">
            {index + 1}
          </div>
        </div>
      ))}
    </Document>
  );
};

export default PDFPreview;